@if(showBar) {
<ul class="action-bar">
   <!-- <li><mat-form-field>
        <mat-label>Saved Filters</mat-label>
        <mat-select [panelWidth]="'auto'">
            <mat-optgroup label="Personal">
                <mat-option value="Filter1">Filter1</mat-option>
                <mat-option value="Filter2"> Filter2</mat-option>
            </mat-optgroup>
            <mat-optgroup label="General">
                <mat-option value="Filter3">Filter3</mat-option>
                <mat-option value="Filter4">Filter4</mat-option>
            </mat-optgroup>

        </mat-select>
    </mat-form-field></li>-->
    @if( assetCount && assetCount.assetsSelected > 0) {
        <!--@if (!collection) { -->
            @if(user && user.effectiveRoles.ROLE_COLLECTION_ACCESS || user && user.effectiveRoles.ROLE_COLLECTION_CREATE ) {
                <li>
                    <button mat-icon-button [matTooltip]="'action.addtocollection'|translate"  (click)="addToCollection()">
                        <mat-icon aria-hidden="false" fontIcon="add"></mat-icon>
                    </button>
                </li>
            }


       <!-- } -->
        @if (collection) {
            @if(user && user.effectiveRoles.ROLE_COLLECTION_ACCESS  && collection.permissions.canAddOrRemoveAsset) {
                <li>
                    <button mat-icon-button [matTooltip]="'action.removefromcollection'|translate" (click)="removeFromCollection()">
                        <mat-icon  aria-hidden="false" fontIcon="remove" ></mat-icon>
                    </button>
                </li>
            }
        }
        <li>
            @if(user && user.effectiveRoles.ROLE_ASSET_EDIT) {
            <button mat-icon-button [matTooltip]="'action.editassets'|translate" (click)="startEdit()">
                <mat-icon  aria-hidden="false" fontIcon="edit" ></mat-icon>
            </button>
            }
        </li>
        <li>
            @if(user && user.effectiveRoles.ROLE_ASSET_DELETE && !collection) {
                <button mat-icon-button [matTooltip]="'action.deleteAssets'|translate" (click)="deleteAssets()">
                    <mat-icon  aria-hidden="false" fontIcon="delete" ></mat-icon>
                </button>
            }
        </li>
        <li>
             <!-- create collection -->
            @if(user && user.effectiveRoles.ROLE_COLLECTION_CREATE) {
            <button mat-icon-button [matTooltip]="'action.shareassets'|translate" (click)="shareAssets()">
                <mat-icon  aria-hidden="false" fontIcon="share" ></mat-icon>
            </button>
            }
        </li>
        <li>
            @if(collection && collection.permissions.canDownload) {
                <button mat-icon-button (click)="downloadAssets()" [matTooltip]="'action.downloadassets'|translate">
                    @if(assetCount.assetsSelected > maxDownloads) {
                        <mat-icon  fontIcon="file_download_off"></mat-icon>
                    } @else {
                        <mat-icon  fontIcon="download"></mat-icon>
                    }

                </button>
            }
            @if(readOnlyCollection && readOnlyCollection.permission === 'download') {
                <button mat-icon-button (click)="downloadAssets()" [matTooltip]="'action.downloadassets'|translate">
                    @if(assetCount.assetsSelected > maxDownloads) {
                        <mat-icon  fontIcon="file_download_off"></mat-icon>
                    } @else {
                        <mat-icon  fontIcon="download"></mat-icon>
                    }
                </button>
            }
            @if(!collection && !readOnlyCollection) {
                @if(user && user.effectiveRoles.ROLE_ASSET_DOWNLOAD) {
                    <button mat-icon-button (click)="downloadAssets()" [matTooltip]="'action.downloadassets'|translate">
                        @if(assetCount.assetsSelected > maxDownloads) {
                            <mat-icon  fontIcon="file_download_off"></mat-icon>
                        } @else {
                            <mat-icon  fontIcon="download"></mat-icon>
                        }
                    </button>
                }
            }
        </li>
    }
    @if(collection) {
        @if(collection.permissions.canDownload) {
            @if(assetCount && assetCount.assetsTotal <= maxDownloads && assetCount.assetsTotal >= 1) {
                <button (click)="downloadAllAssets()"  mat-button><mat-icon fontIcon="download"></mat-icon>{{'downloadAll' | translate}}</button>
            }
            @if(assetCount && assetCount.assetsTotal > maxDownloads) {
                <span [matTooltip]="'toManyAssets'| translate">
                      <button  [disabled]="true"  mat-button><mat-icon fontIcon="download"></mat-icon>{{'downloadAll' | translate}}</button>
                </span>

            }
        }

    }
    @if (readOnlyCollection && readOnlyCollection.permission === 'download') {
        @if(assetCount && assetCount.assetsTotal <= maxDownloads && assetCount.assetsTotal >= 1) {
            <button (click)="downloadAllAssets()"  mat-button><mat-icon fontIcon="download"></mat-icon>{{'downloadAll' | translate}}</button>
        }
        @if(assetCount && assetCount.assetsTotal > maxDownloads) {
            <span [matTooltip]="'toManyAssets'| translate">
                <button  [disabled]="true"  mat-button><mat-icon fontIcon="download"></mat-icon>{{'downloadAll' | translate}}</button>
            </span>
        }
    }
   <!-- @if(assetCount) {
        <li>
            <mat-form-field>
                <mat-label>Select..</mat-label>
                <mat-select [panelWidth]="'auto'">
                    <mat-option [value]="AssetAction.selectVisible">
                    <span class="option-wrapper">
                    <span class="action">{{AssetAction.selectVisible | translate}}</span>
                        <span class="count">{{assetCount.assetsVisible}}</span>
                    </span> </mat-option>
                    <mat-option [value]="AssetAction.selectAll">
                    <span class="option-wrapper">
                    <span class="action">{{AssetAction.selectAll | translate}}</span>
                        <span class="count">{{assetCount.assetsTotal}}</span>
                    </span> </mat-option>
                    <mat-option [value]="AssetAction.selectNone">
                    <span class="option-wrapper">
                    <span class="action">{{AssetAction.selectNone | translate}}</span>
                    </span> </mat-option>
                </mat-select>
            </mat-form-field>
        </li>
    }-->


</ul>
}
